import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"hamburger\"><path d=\"M48.9 52.3H15.1c-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8h33.8c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.8 3.8zM48.9 35.8H15.1c-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8h33.8c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.8 3.8zM48.9 19.6H15.1c-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8h33.8c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.8 3.8z\" class=\"st0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol